module.exports = __webpack_public_path__ + "fff9da9aa85f4a310a94e44a917ab03a.svg";